var FilterLocationsModule = /** @class */ (function () {
    function FilterLocationsModule() {
    }
    return FilterLocationsModule;
}());
export { FilterLocationsModule };
